import React, { Component } from "react";

const Dropdown = ({ isOpen, toggle }) => {
  return (
    <div
      className={
        isOpen
          ? "grid grid-rows-4 text-center fixed bg-white w-full z-50 top-16"
          : "hidden"
      }
      onClick={toggle}
    >
      <ul>
        <li class=" hover:text-main-color">
          <a href="/" class="relative block py-3 lg:p-6 text-sm lg:text-base ">
            Home
          </a>
        </li>
        <li class="toggleable  hover:text-main-color z-50">
          <input
            type="checkbox"
            value="selected"
            id="toggle-three"
            class="toggle-input"
          />
          <label for="toggle-three" class="block cursor-pointer py-3 text-sm">
            Solutions
          </label>
          <div class="mega-menu mb-16 sm:mb-0 shadow-xl bg-white pt-5 rounded-b-lg z-50">
            <div class="w-full flex flex-wrap justify-between">
              <ul class=" flex justify-center w-full border-b sm:border-r lg:border-b-0">
                <li class="flex items-center justify-center p-4 px-2 border-b border-r border-t w-1/2">
                  <div className="ml-3">
                    <a href="/panelo-sign" class=" text-xs text-desc-text mb-2">
                      PANELO SIGN
                    </a>
                  </div>
                </li>
                <li class="flex items-center justify-center p-4 px-2 border-b border-r border-t  w-1/2">
                  <div className="ml-3">
                    <a href="/panelo-cms" class=" text-xs text-desc-text mb-2">
                      PANELO CMS
                    </a>
                  </div>
                </li>
                <li class="flex items-center justify-center p-4 px-2 border-b border-t  w-1/2">
                  <div className="ml-3">
                    <a
                      href="/panelo-vision"
                      class=" text-xs text-desc-text mb-2"
                    >
                      PANELO VISION
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="toggleable  hover:text-main-color">
          <input
            type="checkbox"
            value="selected"
            id="toggle-one"
            class="toggle-input"
          />
          <label for="toggle-one" class="block cursor-pointer py-3 text-sm">
            Application
          </label>
          <div class="mega-menu mb-16 sm:mb-0 shadow-xl bg-white  rounded-b-md z-40">
            <div class="w-full flex flex-wrap justify-between">
              <ul class="w-1/3 border-b border-r lg:border-b-0">
                <li class="flex items-center p-1 py-3 border-b border-t">
                  <div className="ml-3">
                    <a
                      href="/application/digital-menu-board-tv"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Digital Menu Boards for TV
                      <p class="text-desc-text text-xs font-normal">
                        Manage price/menu update instanly
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center  p-1 py-3 border-b ">
                  <div className="ml-3">
                    <a
                      href="/application/gym-and-fitness"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Gym & Fitness
                      <p class="text-desc-text text-xs font-normal">
                        Engage customers with training videos or health tips
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 border-b ">
                  <div className="ml-3">
                    <a
                      href="/application/retail"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Retail
                      <p class="text-desc-text text-xs font-normal">
                        Enhance the shopping experience of your customers
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 ">
                  <div className="ml-3">
                    <a
                      href="/application/education"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Education
                      <p class="text-desc-text text-xs font-normal">
                        Educate your students the right way !
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="w-1/3 border-b border-r lg:border-b-0">
                <li class="flex items-center p-1 py-3 border-b border-t">
                  <div className="ml-3">
                    <a
                      href="/application/religious-venues"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Religious <br /> Venues
                      <p class="text-desc-text text-xs font-normal">
                        Remodel Church facilities for inviting experiences
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 border-b">
                  <div className="ml-3">
                    <a
                      href="/application/corporate-office"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Corporate Office
                      <p class="text-desc-text text-xs font-normal pb-4">
                        Creates dynamic and healthy culture <br />
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 border-b">
                  <div className="ml-3">
                    <a
                      href="/application/move-theaters"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Move Theaters
                      <p class="text-desc-text text-xs font-normal pb-4">
                        Add value to your viewer’s experience
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 ">
                  <div className="ml-3">
                    <a
                      href="/application/digital-menu-for-restaurant"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Digital Menu for Restaurant
                      <p class="text-desc-text text-xs font-normal">
                        Wonderful guest experience with increase in sales
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="w-1/3 border-b border-r lg:border-b-0">
                <li class="flex items-center p-1 py-3 border-b border-t">
                  <div className="ml-3">
                    <a
                      href="/application/qr-code-restaurant-menu"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      QR Code Restaurant Menu
                      <p class="text-desc-text text-xs font-normal">
                        Make your restaurant more safe to eat
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 border-b">
                  <div className="ml-3">
                    <a
                      href="/application/art-gallery"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Art Gallery
                      <p class="text-desc-text text-xs font-normal pb-4">
                        Promote your art with eye soothing Digital Displays{" "}
                      </p>
                    </a>
                  </div>
                </li>
                <li class="flex items-center p-1 py-3 border-b">
                  <div className="ml-3">
                    <a
                      href="/application/health-care"
                      class="font-bold text-xs text-desc-text mb-2"
                    >
                      Health Care
                      <p class="text-desc-text text-xs font-normal pb-8">
                        Build Connected Facilities
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class=" hover:text-main-color">
          <a
            href="/blog"
            class="relative block lg:p-6 py-3 text-sm lg:text-base"
          >
            Blog
          </a>
        </li>
        <li class="toggleable  hover:text-main-color">
          <input
            type="checkbox"
            value="selected"
            id="toggle-two"
            class="toggle-input"
          />
          <label for="toggle-two" class="block cursor-pointer py-3 text-sm">
            Partners
          </label>
          <div class="mega-menu mb-16 sm:mb-0 shadow-xl bg-white pt-5 rounded-b-lg z-30">
            <div class="w-full flex flex-wrap justify-between">
              <ul class=" flex justify-center w-full border-b sm:border-r lg:border-b-0">
                <li class="flex items-center justify-center p-9 px-6 border-b border-r border-t w-1/2">
                  <div className="ml-3">
                    <a
                      href="/white-label-partner"
                      class=" text-xs text-desc-text mb-2"
                    >
                      White Label Partners
                    </a>
                  </div>
                </li>
                <li class="flex items-center justify-center p-9 px-6 border-b border-t  w-1/2">
                  <div className="ml-3">
                    <a
                      href="/channel-partner"
                      class=" text-xs text-desc-text mb-2"
                    >
                      Channel Partner
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class=" hover:text-main-color">
          <a
            href="/pricing"
            class="relative block py-3 lg:p-6 text-sm lg:text-base"
          >
            Pricing
          </a>
        </li>
      </ul>
      <div>
        <ul className="flex items-center justify-center mt-6 mb-6">
          <li class=" hover:text-main-color">
            <a
              href="/login"
              class="relative block px-5 py-2 lg:p-6 text-sm lg:text-base"
            >
              Login
            </a>
          </li>
          <li class="bg-main-color hover:bg-orange-dark rounded-md text-white">
            <a
              href="/signup"
              class="relative block text-sm px-5 py-2 lg:text-base"
            >
              Sign Up
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
